import makeApiRequest from '../../../api/makeApiRequest';
import FullNameWithTitle from '../../../utils/getFullNameWithTitle';

const normalizeUser = sender => ({
  ...sender,
  fullNameWithTitle: FullNameWithTitle.get(sender),
  initials: `${sender.firstName[0]}${sender.lastName[0]}`,
});

const unreadChats = {
  name: 'unreadChats',
  state: {
    chats: [],
    total: 0,
    remaining: 0,
    state: 'idle',
  },
  reducers: {
    onLoaded(state, { data, meta }) {
      const chats = data
        .filter(
          ({ attributes }) =>
            typeof attributes.lastMessage !== 'undefined' &&
            typeof attributes.lastMessage.sender !== 'undefined',
        )
        .map(contact => ({
          id: contact.id,
          ...contact.attributes,
          lastMessage: {
            ...contact.attributes.lastMessage,
            sender: normalizeUser(contact.attributes.lastMessage.sender),
          },
        }));
      return {
        ...state,
        chats,
        total: meta.unreadTotal,
        remaining: meta.unreadRemaining,
        state: 'loaded',
      };
    },
    onMessageDeleted: (state, message) => {
      const { chats } = state;
      if (chats.find(m => m.lastMessage.id === message.id)) {
        return {
          ...state,
          chats: chats.map(chat =>
            chat.lastMessage.id === message.id
              ? {
                  ...chat,
                  lastMessage: { ...chat.lastMessage, deletedAt: message.deletedAt },
                }
              : chat,
          ),
        };
      }
      return state;
    },
    onUpdateAvailable: state => ({ ...state, state: 'updateAvailable' }),
  },
  messageListeners: {
    MESSAGE_DELETED({ payload }) {
      this.onMessageDeleted(payload);
    },
    SESSION_MSG_DELETED({ payload }) {
      this.onMessageDeleted(payload);
    },
    MESSAGE_CREATED() {
      this.onUpdateAvailable();
    },
    SESSION_MSG_CREATED() {
      this.onUpdateAvailable();
    },
  },
  effects: {
    async load(_, { oidcSession }) {
      const url = '/unread-chats';
      const [request] = makeApiRequest(url, oidcSession);
      const { error, data } = await request;
      if (!error) return this.onLoaded(data);
      throw error;
    },
  },
};

export default unreadChats;
